import styled, { css } from 'styled-components';

import { mediaConfined, mediaWide } from '@xing-com/layout-tokens';
import {
  scale050,
  scale070,
  scale100,
  scale120,
  scale140,
  spaceM,
} from '@xing-com/tokens';

import { SkeletonRectangle } from '../';

import type {
  SkeletonHeadlineAlignment,
  SkeletonHeadlineSize,
} from './skeleton-headline.types';

type HeadlineTransientProps = {
  $alignment?: SkeletonHeadlineAlignment;
};

type HeadlineRowTransientProps = {
  $amountRows: number;
  $size?: SkeletonHeadlineSize;
  $sizeConfined?: SkeletonHeadlineSize;
  $sizeWide?: SkeletonHeadlineSize;
};

// *** Sizes ***
export const sizes = {
  small: css`
    height: ${scale100};
    margin-block-end: ${scale050};
  `,
  medium: css`
    height: ${scale120};
    margin-block-end: ${spaceM};
  `,
  large: css`
    height: ${scale140};
    margin-block-end: ${scale070};
  `,
};

// *** Text Alignments ***
export const alignments = {
  left: css`
    justify-content: flex-start;
  `,
  center: css`
    justify-content: center;
  `,
  right: css`
    justify-content: flex-end;
  `,
};

// *** Components ***
export const Headline = styled.div<HeadlineTransientProps>`
  display: flex;
  flex-wrap: wrap;
  ${({ $alignment }) => {
    switch ($alignment) {
      case 'left':
        return alignments.left;
      case 'center':
        return alignments.center;
      case 'right':
        return alignments.right;
      default:
        return $alignment satisfies undefined;
    }
  }};
`;

export const HeadlineRow = styled(SkeletonRectangle)<HeadlineRowTransientProps>`
  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return sizes.small;
      case 'medium':
        return sizes.medium;
      case 'large':
        return sizes.large;
      default:
        return $size satisfies undefined;
    }
  }};

  @media ${mediaConfined} {
    ${({ $sizeConfined }) => {
      switch ($sizeConfined) {
        case 'small':
          return sizes.small;
        case 'medium':
          return sizes.medium;
        case 'large':
          return sizes.large;
        default:
          return $sizeConfined satisfies undefined;
      }
    }};
  }

  @media ${mediaWide} {
    ${({ $sizeWide }) => {
      switch ($sizeWide) {
        case 'small':
          return sizes.small;
        case 'medium':
          return sizes.medium;
        case 'large':
          return sizes.large;
        default:
          return $sizeWide satisfies undefined;
      }
    }};
  }

  ${({ $amountRows }) => {
    return (
      $amountRows > 1 &&
      css`
        &:last-child {
          width: 66%;
        }
      `
    );
  }};

  &:last-child {
    margin-block-end: 0;
  }
`;
